<button class="btn-icon" [ngClass]="{'active': selected}" (click)="open()" type="button">
  {{ label }}<streamline-icon aria-hidden="true" name="riseStorage" class="storage-selector-icon" [ngClass]="{'icon-right': label}" width="14" height="14"></streamline-icon>
</button>
